export default "__VITE_ASSET__BhhdjJMt__"